module.exports = "https://trybtryb-legacy.web.app/img/square-over-desktop.3fd2c278.svg";